module.exports = __webpack_public_path__ + "static/media/error.aaa35d55.png";